import { parsePhoneNumber } from 'libphonenumber-js'
import axios from "axios"

export const TypingValidateMobile = (number, country = 'AU') => {
  try{
    const parsed = parsePhoneNumber(number, country)
    return {
      intl_number: parsed && parsed.formatInternational(),
      is_valid: parsed && parsed.isValid() && parsed.getType() === 'MOBILE',
      org_number: number,
    }
  } catch (e) {
    return {
      intl_number: null,
      is_valid: false,
      org_number: number,
    }
  }
}

export const TypingValidateNumber = (number, country = 'AU') => {
  try{
    const parsed = parsePhoneNumber(number, country)
    return {
      intl_number: parsed && parsed.formatInternational(),
      is_valid: parsed && parsed.isValid() && ['MOBILE', 'FIXED_LINE', 'FIXED_LINE_OR_MOBILE'].includes(parsed.getType()),
      org_number: number,
    }
  } catch (e) {
    return {
      intl_number: null,
      is_valid: false,
      org_number: number,
    }
  }
}

export const TypingValidateEmail = (email) => {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return { value: email, is_valid: re.test(email) };
}

export const invertColor = (hex) => {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    // invert color components
    var r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
        g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
        b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
    // pad each with zeros and return
    return '#' + padZero(r) + padZero(g) + padZero(b);
}

export const contrastText = (hex) => {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
    // https://stackoverflow.com/a/3943023/112731
    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
        ? '#000000'
        : '#FFFFFF';
}

export const changeColor = (color, amount) => { // #FFF not supported rather use #FFFFFF
    const clamp = (val) => Math.min(Math.max(val, 0), 0xFF)
    const fill = (str) => ('00' + str).slice(-2)

    const num = parseInt(color.substr(1), 16)
    const red = clamp((num >> 16) + amount)
    const green = clamp(((num >> 8) & 0x00FF) + amount)
    const blue = clamp((num & 0x0000FF) + amount)
    return '#' + fill(red.toString(16)) + fill(green.toString(16)) + fill(blue.toString(16))
}

export const padZero = (str, len) => {
    len = len || 2;
    var zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
}

export const getClientInfo = async () => {
  const cf_response = await axios.get(`https://cloudflare.com/cdn-cgi/trace`)
  const trace = cf_response?.data?.split(/\r?\n/) ?? []
  let ip = "";
  let loc = "";
  let uag = "";
  let colo = "";
  for (let entry of trace) {
    if (entry && entry.substring(0, 2) === 'ip') {
      ip = entry.substring(3);
    }
    if (entry && entry.substring(0, 3) === 'loc') {
      loc = entry.substring(4);
    }
    if (entry && entry.substring(0, 3) === 'uag') {
      uag = entry.substring(4);
    }
    if (entry && entry.substring(0, 4) === 'colo') {
      colo = entry.substring(5);
    }
  }
  return { ip, loc, uag, colo }
}
